module.exports = __webpack_public_path__ + "static/media/cold_3.09bc53f4.png";